import { message } from 'ant-design-vue';
import Clipboard from 'clipboard';
function clipboardSuccess(text) {
  message.success(`${text} 复制成功`);
}
function clipboardError() {
  message.error('Copy error');
}
export default function handleClipboard(text, event, isMsg = true) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  });
  clipboard.on('success', () => {
    if (isMsg) {
      clipboardSuccess(text);
    }
    clipboard.destroy();
  });
  clipboard.on('error', () => {
    clipboardError();
    clipboard.destroy();
  });
  clipboard.onClick(event);
}
export function clipboardCopy(rest, text, event, msg) {
  console.log(text === '', text === 'undefined', text, '----text-----', window.isSecureContext, navigator.clipboard);
  if (rest) {
    console.log('rest');
    // navigator clipboard 需要https等安全上下文
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText('');
      return;
    }
  } else {
    if (text === '' || text === 'undefined') {
      console.log(text, '-------false text为空--------');
      // navigator clipboard 需要https等安全上下文
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText('');
      }
      message.error(msg);
      return;
    } else {
      const clipboard = new Clipboard(event.target, {
        text: () => text
      });
      clipboard.on('success', () => {
        message.success(msg);
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        message.error('Copy error');
        clipboard.destroy();
      });
      clipboard.onClick(event);
    }
  }
}